<template>
<div>
  <logo :text="'Gigavoid'"/>
  <div class="wrapper">
    <posts :offset="0" :limit="1" :short="true"/>
  </div>
</div>
</template>

<script>
import Logo from '@/components/logo'
import Posts from '@/components/posts'

export default {
  components: {
    Logo,
    Posts
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue